import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { GraphQLError } from 'graphql-request/dist/types';
import { print } from 'graphql'
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BuildingFloor: any;
  City: any;
  Coordinate: any;
  /** UTC DateTime (in ISO format) */
  Date: any;
  Distance: any;
  EmailAddress: any;
  NonNegativeInteger: any;
  PositiveInteger: any;
  SquareMeters: any;
  TelephoneNumber: any;
  Url: any;
  Year: any;
};

export type Address = {
  __typename?: 'Address';
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  zipCode: Scalars['String'];
};

export type AddressIn = {
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  zipCode: Scalars['String'];
};

export type Agency = {
  __typename?: 'Agency';
  address?: Maybe<Scalars['String']>;
  emailContact: Scalars['EmailAddress'];
  logo?: Maybe<Scalars['Url']>;
  name: Scalars['String'];
  telephoneNumberContact: Scalars['TelephoneNumber'];
  website?: Maybe<Scalars['Url']>;
};

export type AgencyIn = {
  address?: Maybe<Scalars['String']>;
  emailContact: Scalars['EmailAddress'];
  logo?: Maybe<Scalars['Url']>;
  name: Scalars['String'];
  telephoneNumberContact: Scalars['TelephoneNumber'];
  website?: Maybe<Scalars['Url']>;
};

export type Area = {
  __typename?: 'Area';
  area: Scalars['SquareMeters'];
};

export type AreaDescription = {
  __typename?: 'AreaDescription';
  center: Array<Maybe<Scalars['Coordinate']>>;
  cities: Array<CityAreaDescription>;
  listingCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  value: Scalars['String'];
};

export type AreaFilter = {
  byArea?: Maybe<Scalars['String']>;
  byCity?: Maybe<Scalars['City']>;
  byCountry: Country;
  onlyArea?: Maybe<Scalars['Boolean']>;
  withListingCount?: Maybe<Scalars['Boolean']>;
};

export type Areas = {
  __typename?: 'Areas';
  areas: Array<Scalars['SquareMeters']>;
};


export enum CardinalPoint {
  East = 'EAST',
  North = 'NORTH',
  South = 'SOUTH',
  West = 'WEST'
}


export type CityAreaDescription = {
  __typename?: 'CityAreaDescription';
  center: Array<Maybe<Scalars['Coordinate']>>;
  listingCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  value: Scalars['String'];
  zones: Array<ZoneAreaDescription>;
};

export type CityDescription = {
  __typename?: 'CityDescription';
  boundaries: Array<Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Coordinate']>>>>>>>>;
  center: Array<Maybe<Scalars['Coordinate']>>;
  description: Array<Description>;
  name: Scalars['String'];
  referenceArea: Scalars['String'];
  slug: Scalars['String'];
  value?: Maybe<Scalars['City']>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};

export enum CoolingSystem {
  Autonomous = 'AUTONOMOUS',
  None = 'NONE',
  ReadyForInstallation = 'READY_FOR_INSTALLATION',
  Shared = 'SHARED'
}


export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Coordinate'];
  lon: Scalars['Coordinate'];
};

export type CoordinatesIn = {
  lat: Scalars['String'];
  lon: Scalars['String'];
};

export type Counter = {
  __typename?: 'Counter';
  counter: Scalars['NonNegativeInteger'];
};

export enum Country {
  Italy = 'ITALY',
  Spain = 'SPAIN'
}

export type CreateListingPayload = {
  __typename?: 'CreateListingPayload';
  listing?: Maybe<Listing>;
  meta: CreateListingPayloadMeta;
};

export type CreateListingPayloadMeta = {
  __typename?: 'CreateListingPayloadMeta';
  location: Scalars['Url'];
  status: UpdateResult;
};

export enum Currency {
  Eur = 'EUR'
}


export type DeleteListingPayload = {
  __typename?: 'DeleteListingPayload';
  listing?: Maybe<Scalars['ID']>;
  meta: DeleteListingPayloadMeta;
};

export type DeleteListingPayloadMeta = {
  __typename?: 'DeleteListingPayloadMeta';
  status: UpdateResult;
};

export type Description = {
  __typename?: 'Description';
  language: Language;
  text: Scalars['String'];
};

export type DescriptionIn = {
  language: Language;
  text: Scalars['String'];
};



export enum EnergyRating {
  A = 'A',
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  Aplus = 'APLUS',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  None = 'NONE',
  PendingRequest = 'PENDING_REQUEST'
}

export enum EnergyRatingCategory {
  Ace = 'ACE',
  Ape = 'APE'
}

export enum EstateRegistryClass {
  F2 = 'F2',
  A7 = 'A7',
  B3 = 'B3',
  E9 = 'E9',
  B4 = 'B4',
  A3 = 'A3',
  B7 = 'B7',
  A8 = 'A8',
  C5 = 'C5',
  F3 = 'F3',
  B8 = 'B8',
  E4 = 'E4',
  C2 = 'C2',
  F6 = 'F6',
  C4 = 'C4',
  A9 = 'A9',
  None = 'NONE',
  D7 = 'D7',
  A1 = 'A1',
  D1 = 'D1',
  C3 = 'C3',
  D5 = 'D5',
  A2 = 'A2',
  B1 = 'B1',
  A5 = 'A5',
  F1 = 'F1',
  B2 = 'B2',
  D6 = 'D6',
  C6 = 'C6',
  A10 = 'A10',
  C1 = 'C1',
  B6 = 'B6',
  F4 = 'F4',
  F5 = 'F5',
  E3 = 'E3',
  A11 = 'A11',
  D3 = 'D3',
  E7 = 'E7',
  D4 = 'D4',
  E1 = 'E1',
  B5 = 'B5',
  A4 = 'A4',
  D10 = 'D10',
  E8 = 'E8',
  C7 = 'C7',
  E5 = 'E5',
  D8 = 'D8',
  E6 = 'E6',
  E2 = 'E2',
  D2 = 'D2',
  D9 = 'D9',
  A6 = 'A6'
}

export type Filter = {
  byArea?: Maybe<FilterByArea>;
  byBathrooms?: Maybe<FilterByRooms>;
  byBedrooms?: Maybe<FilterByRooms>;
  byCity?: Maybe<Scalars['City']>;
  byConstructionYear?: Maybe<FilterByYear>;
  byCoordinates?: Maybe<FilterByCoordinates>;
  byFloor?: Maybe<Array<FloorFilter>>;
  byGeoSlug?: Maybe<Array<Maybe<Scalars['String']>>>;
  byHeatingSystem?: Maybe<Array<HeatingSystemFilter>>;
  byPrice?: Maybe<FilterByPrice>;
  byPublishedAt?: Maybe<FilterByPublishedAt>;
  byResidentialType?: Maybe<Array<ResidentialTypeFilter>>;
  byRooms?: Maybe<FilterByRooms>;
  byStateAtDeed?: Maybe<Array<StateAtDeedFilter>>;
  byStateOfMaintenance?: Maybe<Array<StateOfMaintenanceFilter>>;
  byZone?: Maybe<Array<Maybe<Scalars['String']>>>;
  onlyCasavo?: Maybe<Scalars['Boolean']>;
  onlyWithBalcony?: Maybe<Scalars['Boolean']>;
  onlyWithBasement?: Maybe<Scalars['Boolean']>;
  onlyWithBox?: Maybe<Scalars['Boolean']>;
  onlyWithConciergeService?: Maybe<Scalars['Boolean']>;
  onlyWithCoolingSystem?: Maybe<Scalars['Boolean']>;
  onlyWithElevator?: Maybe<Scalars['Boolean']>;
  onlyWithGarden?: Maybe<Scalars['Boolean']>;
  onlyWithParking?: Maybe<Scalars['Boolean']>;
  onlyWithPool?: Maybe<Scalars['Boolean']>;
  onlyWithTerrace?: Maybe<Scalars['Boolean']>;
};

export type FilterByArea = {
  from?: Maybe<Scalars['NonNegativeInteger']>;
  to?: Maybe<Scalars['NonNegativeInteger']>;
};

export type FilterByCoordinates = {
  distance?: Maybe<Scalars['Distance']>;
  lat: Scalars['Coordinate'];
  lon: Scalars['Coordinate'];
};

export type FilterByCountry = {
  byCountry?: Maybe<Country>;
};

export type FilterByPrice = {
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

export type FilterByPublishedAt = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export type FilterByRooms = {
  from?: Maybe<Scalars['NonNegativeInteger']>;
  to?: Maybe<Scalars['NonNegativeInteger']>;
};

export type FilterByYear = {
  from?: Maybe<Scalars['NonNegativeInteger']>;
  to?: Maybe<Scalars['NonNegativeInteger']>;
};

export type Floor = {
  __typename?: 'Floor';
  buildingFloor: Scalars['BuildingFloor'];
  entireFloor?: Maybe<Scalars['Boolean']>;
  floorShift: FloorShift;
};

export enum FloorFilter {
  Any = 'ANY',
  Basement = 'BASEMENT',
  GroundFloor = 'GROUND_FLOOR',
  LastFloor = 'LAST_FLOOR',
  MidFloor = 'MID_FLOOR',
  Raised = 'RAISED'
}

export type FloorIn = {
  buildingFloor: Scalars['BuildingFloor'];
  entireFloor?: Maybe<Scalars['Boolean']>;
  floorShift: FloorShift;
};

export enum FloorPosition {
  Basement = 'BASEMENT',
  GroundFloor = 'GROUND_FLOOR',
  LastFloor = 'LAST_FLOOR',
  MidFloor = 'MID_FLOOR',
  Raised = 'RAISED'
}

export enum FloorShift {
  Lowered = 'LOWERED',
  None = 'NONE',
  Raised = 'RAISED'
}

export enum Furnishings {
  FullyFurnished = 'FULLY_FURNISHED',
  NotFurnished = 'NOT_FURNISHED',
  PartiallyFurnished = 'PARTIALLY_FURNISHED'
}

export enum Glazing {
  Double = 'DOUBLE',
  Single = 'SINGLE',
  Triple = 'TRIPLE'
}

export enum HeatingSystem {
  Autonomous = 'AUTONOMOUS',
  None = 'NONE',
  Shared = 'SHARED'
}

export enum HeatingSystemFilter {
  Any = 'ANY',
  Autonomous = 'AUTONOMOUS',
  None = 'NONE',
  Shared = 'SHARED'
}

export enum Kitchen {
  Habitable = 'HABITABLE',
  HalfHabitable = 'HALF_HABITABLE',
  Kitchenette = 'KITCHENETTE',
  Open = 'OPEN'
}

export enum Language {
  En = 'EN',
  Es = 'ES',
  It = 'IT'
}

export type Listing = {
  __typename?: 'Listing';
  recreationRoom?: Maybe<Scalars['Boolean']>;
  gardenArea?: Maybe<Scalars['SquareMeters']>;
  hydromassage?: Maybe<Scalars['Boolean']>;
  residentialType: ResidentialType;
  terrace?: Maybe<Quantifier>;
  kitchen?: Maybe<Kitchen>;
  propertyId: Scalars['ID'];
  address: Address;
  tennisCourt?: Maybe<Scalars['Boolean']>;
  slug: Scalars['ID'];
  exposure: Array<CardinalPoint>;
  wallCabinet?: Maybe<Scalars['Boolean']>;
  balcony?: Maybe<Quantifier>;
  lastRenovationYear?: Maybe<Scalars['Year']>;
  livingRooms?: Maybe<Scalars['NonNegativeInteger']>;
  agency: Agency;
  walkingArea?: Maybe<Scalars['SquareMeters']>;
  publicUrl: Scalars['Url'];
  glazing?: Maybe<Glazing>;
  energyRating: EnergyRating;
  energyRatingCategory?: Maybe<EnergyRatingCategory>;
  sellingPrice?: Maybe<Money>;
  elevator?: Maybe<Scalars['Boolean']>;
  condoFeesPerYear?: Maybe<Money>;
  garret?: Maybe<Scalars['Boolean']>;
  planimetry?: Maybe<Planimetry>;
  emailContact: Scalars['EmailAddress'];
  entranceFloor: Scalars['BuildingFloor'];
  disabledAccess?: Maybe<Scalars['Boolean']>;
  coolingSystem?: Maybe<CoolingSystem>;
  estateRegistryClass: EstateRegistryClass;
  coordinates: Coordinates;
  stateAtDeed: StateAtDeed;
  recreationRoomArea?: Maybe<Scalars['SquareMeters']>;
  basementArea?: Maybe<Scalars['SquareMeters']>;
  title: Array<Description>;
  rooms: Scalars['PositiveInteger'];
  basement?: Maybe<Scalars['Boolean']>;
  fastInternet?: Maybe<Scalars['Boolean']>;
  pointsOfInterest: Array<Poi>;
  telephoneNumberContact?: Maybe<Scalars['TelephoneNumber']>;
  floors: Array<Floor>;
  estateRegistryArea?: Maybe<Scalars['SquareMeters']>;
  pool?: Maybe<Scalars['Boolean']>;
  heatingSystem: HeatingSystem;
  commercialArea: Scalars['SquareMeters'];
  alarmSystem?: Maybe<Scalars['Boolean']>;
  stateOfMaintenance: StateOfMaintenance;
  bathrooms?: Maybe<Scalars['PositiveInteger']>;
  conciergeService?: Maybe<Scalars['Boolean']>;
  constructionYear?: Maybe<Scalars['Year']>;
  fireplace?: Maybe<Scalars['Boolean']>;
  armoredDoor?: Maybe<Scalars['Boolean']>;
  zone?: Maybe<ZoneDescription>;
  electricGate?: Maybe<Scalars['Boolean']>;
  garretArea?: Maybe<Scalars['SquareMeters']>;
  updatedAt: Scalars['Date'];
  sharedGarden?: Maybe<Scalars['Boolean']>;
  box?: Maybe<Quantifier>;
  id: Scalars['ID'];
  floorPosition: Array<FloorPosition>;
  ownedByCasavo: Scalars['Boolean'];
  description: Array<ListingDescription>;
  country: Country;
  showStreetNumber: Scalars['Boolean'];
  entranceVideoPhone?: Maybe<Scalars['Boolean']>;
  exclusiveSellingMandate?: Maybe<Scalars['Boolean']>;
  superCondo?: Maybe<Scalars['Boolean']>;
  publishedAt: Scalars['Date'];
  parkingSpaces?: Maybe<Scalars['NonNegativeInteger']>;
  condo?: Maybe<Scalars['Boolean']>;
  homeAutomationSystem?: Maybe<Scalars['Boolean']>;
  garden?: Maybe<Scalars['Boolean']>;
  habitabilityCertificate?: Maybe<Scalars['Boolean']>;
  poolArea?: Maybe<Scalars['SquareMeters']>;
  casavoDirectSale: Scalars['Boolean'];
  bedrooms?: Maybe<Scalars['NonNegativeInteger']>;
  energyPerformanceIndex?: Maybe<Scalars['PositiveInteger']>;
  tvSystem?: Maybe<Scalars['Boolean']>;
  photos?: Maybe<Array<Photo>>;
  disabledFriendly?: Maybe<Scalars['Boolean']>;
  buildingFloors?: Maybe<Scalars['PositiveInteger']>;
  satelliteSystem?: Maybe<Scalars['Boolean']>;
  sharedPool?: Maybe<Scalars['Boolean']>;
  furnishings?: Maybe<Furnishings>;
  virtualTour?: Maybe<VirtualTour>;
  entireBuilding?: Maybe<Scalars['Boolean']>;
  city: Scalars['City'];
  privateNegotiation?: Maybe<Scalars['Boolean']>;
};

export type ListingCount = {
  __typename?: 'ListingCount';
  count?: Maybe<Scalars['PositiveInteger']>;
  label?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type ListingDescription = {
  __typename?: 'ListingDescription';
  language: Language;
  neighbourhoodDescription: Scalars['String'];
  propertyDescription: Scalars['String'];
};

export type ListingDescriptionIn = {
  language: Language;
  neighbourhoodDescription: Scalars['String'];
  propertyDescription: Scalars['String'];
};

export type ListingPayload = {
  __typename?: 'ListingPayload';
  listing?: Maybe<Listing>;
  meta: ListingPayloadMeta;
};

export type ListingPayloadMeta = {
  __typename?: 'ListingPayloadMeta';
  found: Scalars['Boolean'];
};

export type ListingsCountPayload = {
  __typename?: 'ListingsCountPayload';
  listingsCount?: Maybe<Array<Maybe<ListingCount>>>;
};

export type ListingsPayload = {
  __typename?: 'ListingsPayload';
  listings: Array<Maybe<Listing>>;
  meta: ListingsPayloadMeta;
};

export type ListingsPayloadMeta = {
  __typename?: 'ListingsPayloadMeta';
  hasMore: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  inPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type Money = {
  __typename?: 'Money';
  cents?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
};

export type MoneyIn = {
  cents?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
};


export type Paginate = {
  page?: Maybe<Scalars['PositiveInteger']>;
  size: Scalars['PositiveInteger'];
};

export type Photo = {
  __typename?: 'Photo';
  isPrimary?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  url: Scalars['Url'];
};

export type PhotoIn = {
  isPrimary?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  url: Scalars['Url'];
};

export type Planimetry = {
  __typename?: 'Planimetry';
  url: Scalars['Url'];
};

export type PlanimetryIn = {
  url: Scalars['Url'];
};

export type Poi = {
  __typename?: 'Poi';
  coordinates: Coordinates;
  distance: Scalars['Distance'];
  name?: Maybe<Scalars['String']>;
  poiType: PoiType;
};

export enum PoiType {
  BusStop = 'BUS_STOP',
  School = 'SCHOOL',
  Shop = 'SHOP',
  SubwayStation = 'SUBWAY_STATION',
  TrainStation = 'TRAIN_STATION',
  TramStop = 'TRAM_STOP'
}


export type Quantifier = Counter | Area | Areas;

export type QuantifierIn = {
  area?: Maybe<Scalars['SquareMeters']>;
  areas?: Maybe<Array<Scalars['SquareMeters']>>;
  counter?: Maybe<Scalars['NonNegativeInteger']>;
};

export enum ResidentialType {
  Apartment = 'APARTMENT',
  Attic = 'ATTIC',
  House = 'HOUSE',
  Loft = 'LOFT',
  Mansard = 'MANSARD',
  Townhouse = 'TOWNHOUSE',
  Villa = 'VILLA'
}

export enum ResidentialTypeFilter {
  Any = 'ANY',
  Apartment = 'APARTMENT',
  Attic = 'ATTIC',
  House = 'HOUSE',
  Loft = 'LOFT',
  Mansard = 'MANSARD',
  Townhouse = 'TOWNHOUSE',
  Villa = 'VILLA'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Remove listing by id */
  discardListing?: Maybe<DeleteListingPayload>;
  /** Publish/update a listing */
  publishListing?: Maybe<CreateListingPayload>;
};


export type RootMutationTypeDiscardListingArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypePublishListingArgs = {
  privateNegotiation?: Maybe<Scalars['Boolean']>;
  city: Scalars['City'];
  entireBuilding?: Maybe<Scalars['Boolean']>;
  virtualTour?: Maybe<VirtualTourIn>;
  furnishings?: Maybe<Furnishings>;
  sharedPool?: Maybe<Scalars['Boolean']>;
  satelliteSystem?: Maybe<Scalars['Boolean']>;
  buildingFloors?: Maybe<Scalars['PositiveInteger']>;
  disabledFriendly?: Maybe<Scalars['Boolean']>;
  photos?: Maybe<Array<PhotoIn>>;
  tvSystem?: Maybe<Scalars['Boolean']>;
  energyPerformanceIndex?: Maybe<Scalars['PositiveInteger']>;
  bedrooms?: Maybe<Scalars['NonNegativeInteger']>;
  casavoDirectSale?: Scalars['Boolean'];
  poolArea?: Maybe<Scalars['SquareMeters']>;
  habitabilityCertificate?: Maybe<Scalars['Boolean']>;
  garden?: Maybe<Scalars['Boolean']>;
  homeAutomationSystem?: Maybe<Scalars['Boolean']>;
  condo?: Maybe<Scalars['Boolean']>;
  parkingSpaces?: Maybe<Scalars['NonNegativeInteger']>;
  publishedAt: Scalars['Date'];
  superCondo?: Maybe<Scalars['Boolean']>;
  exclusiveSellingMandate?: Maybe<Scalars['Boolean']>;
  entranceVideoPhone?: Maybe<Scalars['Boolean']>;
  showStreetNumber: Scalars['Boolean'];
  country: Country;
  description: Array<ListingDescriptionIn>;
  ownedByCasavo: Scalars['Boolean'];
  id: Scalars['ID'];
  box?: Maybe<QuantifierIn>;
  sharedGarden?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
  garretArea?: Maybe<Scalars['SquareMeters']>;
  electricGate?: Maybe<Scalars['Boolean']>;
  armoredDoor?: Maybe<Scalars['Boolean']>;
  fireplace?: Maybe<Scalars['Boolean']>;
  constructionYear?: Maybe<Scalars['Year']>;
  conciergeService?: Maybe<Scalars['Boolean']>;
  bathrooms?: Maybe<Scalars['PositiveInteger']>;
  stateOfMaintenance: StateOfMaintenance;
  alarmSystem?: Maybe<Scalars['Boolean']>;
  commercialArea: Scalars['SquareMeters'];
  heatingSystem: HeatingSystem;
  pool?: Maybe<Scalars['Boolean']>;
  estateRegistryArea?: Maybe<Scalars['SquareMeters']>;
  floors?: Maybe<Array<FloorIn>>;
  telephoneNumberContact?: Maybe<Scalars['TelephoneNumber']>;
  fastInternet?: Maybe<Scalars['Boolean']>;
  basement?: Maybe<Scalars['Boolean']>;
  rooms: Scalars['PositiveInteger'];
  title: Array<DescriptionIn>;
  basementArea?: Maybe<Scalars['SquareMeters']>;
  recreationRoomArea?: Maybe<Scalars['SquareMeters']>;
  stateAtDeed: StateAtDeed;
  coordinates: CoordinatesIn;
  estateRegistryClass: EstateRegistryClass;
  coolingSystem?: Maybe<CoolingSystem>;
  disabledAccess?: Maybe<Scalars['Boolean']>;
  entranceFloor: Scalars['BuildingFloor'];
  emailContact: Scalars['EmailAddress'];
  planimetry?: Maybe<PlanimetryIn>;
  garret?: Maybe<Scalars['Boolean']>;
  condoFeesPerYear?: Maybe<MoneyIn>;
  elevator?: Maybe<Scalars['Boolean']>;
  sellingPrice?: Maybe<MoneyIn>;
  energyRatingCategory?: Maybe<EnergyRatingCategory>;
  energyRating: EnergyRating;
  glazing?: Maybe<Glazing>;
  walkingArea?: Maybe<Scalars['SquareMeters']>;
  agency: AgencyIn;
  livingRooms?: Maybe<Scalars['NonNegativeInteger']>;
  lastRenovationYear?: Maybe<Scalars['Year']>;
  balcony?: Maybe<QuantifierIn>;
  wallCabinet?: Maybe<Scalars['Boolean']>;
  exposure: Array<CardinalPoint>;
  tennisCourt?: Maybe<Scalars['Boolean']>;
  address: AddressIn;
  propertyId: Scalars['ID'];
  kitchen?: Maybe<Kitchen>;
  terrace?: Maybe<QuantifierIn>;
  residentialType: ResidentialType;
  hydromassage?: Maybe<Scalars['Boolean']>;
  gardenArea?: Maybe<Scalars['SquareMeters']>;
  recreationRoom?: Maybe<Scalars['Boolean']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Get all listings */
  all: ListingsPayload;
  /** Get all areas */
  areas: Array<AreaDescription>;
  /** Get all cities by country */
  cities: Array<CityDescription>;
  /** Get listing by id */
  listingById?: Maybe<ListingPayload>;
  /** Get listings similar to a given listing */
  listingBySimilar: ListingsPayload;
  /** Get listing by slug */
  listingBySlug?: Maybe<ListingPayload>;
  /** Get listing count group by zone filtered by criteria */
  listingCountByZone: ListingsCountPayload;
  /** Get listings filtered and sorted by criteria */
  listingsByFilter: ListingsPayload;
  /** Get top listings */
  topListings: ListingsPayload;
};


export type RootQueryTypeAreasArgs = {
  filter?: Maybe<AreaFilter>;
};


export type RootQueryTypeCitiesArgs = {
  filter: FilterByCountry;
};


export type RootQueryTypeListingByIdArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeListingBySimilarArgs = {
  size?: Maybe<Scalars['PositiveInteger']>;
  slug: Scalars['ID'];
};


export type RootQueryTypeListingBySlugArgs = {
  slug: Scalars['ID'];
};


export type RootQueryTypeListingCountByZoneArgs = {
  filter: Filter;
};


export type RootQueryTypeListingsByFilterArgs = {
  filter: Filter;
  paginate?: Maybe<Paginate>;
  sort?: Maybe<Sort>;
};


export type RootQueryTypeTopListingsArgs = {
  filter: FilterByCountry;
};

export type Sort = {
  by: SortBy;
  direction: SortDirection;
};

export enum SortBy {
  Area = 'AREA',
  Date = 'DATE',
  Price = 'PRICE'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}


export enum StateAtDeed {
  BareOwnership = 'BARE_OWNERSHIP',
  Free = 'FREE',
  Occupied = 'OCCUPIED',
  Rented = 'RENTED',
  Unknown = 'UNKNOWN'
}

export enum StateAtDeedFilter {
  Any = 'ANY',
  BareOwnership = 'BARE_OWNERSHIP',
  Free = 'FREE',
  Occupied = 'OCCUPIED',
  Rented = 'RENTED',
  Unknown = 'UNKNOWN'
}

export enum StateOfMaintenance {
  Habitable = 'HABITABLE',
  NeedRenovation = 'NEED_RENOVATION',
  New = 'NEW',
  Renovated = 'RENOVATED',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

export enum StateOfMaintenanceFilter {
  Any = 'ANY',
  Habitable = 'HABITABLE',
  NeedRenovation = 'NEED_RENOVATION',
  New = 'NEW',
  Renovated = 'RENOVATED',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}


export enum UpdateResult {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}


export type VirtualTour = {
  __typename?: 'VirtualTour';
  url: Scalars['Url'];
};

export type VirtualTourIn = {
  url: Scalars['Url'];
};


export type Zone = {
  __typename?: 'Zone';
  boundaries: Array<Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Coordinate']>>>>>>>>;
  center?: Maybe<Array<Maybe<Scalars['Coordinate']>>>;
  label: Scalars['String'];
  slug: Scalars['String'];
};

export type ZoneAreaDescription = {
  __typename?: 'ZoneAreaDescription';
  listingCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZoneDescription = {
  __typename?: 'ZoneDescription';
  label: Scalars['String'];
  slug: Scalars['String'];
};

export type AreasQueryVariables = Exact<{
  filter?: Maybe<AreaFilter>;
}>;


export type AreasQuery = (
  { __typename?: 'RootQueryType' }
  & { areas: Array<(
    { __typename?: 'AreaDescription' }
    & Pick<AreaDescription, 'value' | 'name'>
    & { cities: Array<(
      { __typename?: 'CityAreaDescription' }
      & Pick<CityAreaDescription, 'value'>
    )> }
  )> }
);

export type CitiesQueryVariables = Exact<{
  filter: FilterByCountry;
}>;


export type CitiesQuery = (
  { __typename?: 'RootQueryType' }
  & { cities: Array<(
    { __typename?: 'CityDescription' }
    & Pick<CityDescription, 'name' | 'slug' | 'center' | 'value' | 'referenceArea'>
    & { description: Array<(
      { __typename?: 'Description' }
      & Pick<Description, 'language' | 'text'>
    )>, zones?: Maybe<Array<Maybe<(
      { __typename?: 'Zone' }
      & Pick<Zone, 'label' | 'slug'>
    )>>> }
  )> }
);


export const AreasDocument = gql`
    query areas($filter: AreaFilter) {
  areas(filter: $filter) {
    value
    name
    cities {
      value
    }
  }
}
    `;
export const CitiesDocument = gql`
    query cities($filter: FilterByCountry!) {
  cities(filter: $filter) {
    name
    slug
    center
    value
    description {
      language
      text
    }
    referenceArea
    zones {
      label
      slug
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();
const AreasDocumentString = print(AreasDocument);
const CitiesDocumentString = print(CitiesDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    areas(variables?: AreasQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data?: AreasQuery | undefined; extensions?: any; headers: Dom.Headers; status: number; errors?: GraphQLError[] | undefined; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<AreasQuery>(AreasDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'areas');
    },
    cities(variables: CitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data?: CitiesQuery | undefined; extensions?: any; headers: Dom.Headers; status: number; errors?: GraphQLError[] | undefined; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<CitiesQuery>(CitiesDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cities');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;